export default __webpack_public_path__ + "static/media/icon-validate-on.dc3d873b.svg";